import { Dialog, Transition } from "@headlessui/react"
import { CashIcon, CreditCardIcon, LocationMarkerIcon, MailIcon, PhoneIcon, TrashIcon, XIcon } from "@heroicons/react/outline"
import Cookies from "js-cookie"
import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import loader from "../../../assets/loader.gif"
import { getLocalStorage, setLocalStorage } from "../../../helpers/session"
import { getCustomerProfile } from "../../../redux/reducers/CustomerProfileReducer"
import axiosInstance from "../../../services/Interceptor"
import Login from "../Login/Login"

export default function QuickBuy() {
	let navigate = useNavigate()
	const token = Cookies.get("access_token")
	const {customerCart} = useSelector((state) => state.customerCart)
	const userCurrentaddress = getLocalStorage("currentAddress", true)
	let [checkoutProduct, setCheckoutProduct] = useState([null])
	const [open, setOpen] = useState(false)
	const dispatch = useDispatch()
	const cartData = customerCart.data

	const [vendorList, setVendorList] = useState([])
	const {customerProfile} = useSelector((state) => state.customerProfile)
	const customerProfilelist = customerProfile.data
	const [voucherData, setVoucherData] = useState(null)
	const [effectCart, setEffectCart] = useState(0)

	/* dispatch */
	useEffect(() => {
		dispatch(getCustomerProfile("profile"))
	}, [])

	const [quickbuy, setQuickbuy] = useState()

	useEffect(() => {
		setQuickbuy(JSON.parse(getLocalStorage("quickbuy")))
	}, [])

	const handleProcessToPay = (e) => {
		if (userCurrentaddress.message) {
			toast.error("No Address!! Plase add addresss product and try to checkout", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			})
		} else if (!customerProfilelist?.user.phone) {
			toast.error("No Phone Number!! Plase add phone number and try to checkout", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			})
		} else {
			const order = {
				product_id: quickbuy.product_id,
				product_variation_id: quickbuy.product_variation_id,
				delivery_type: quickbuy.delivery_type,
				quantity: quickbuy.product_quantity,
				address_id: userCurrentaddress.id,
			}

			axiosInstance
				.post("orders/api/v1/orders/customer/quick-buy/", order)
				.then((res) => {
					setLocalStorage("order-success", res.data)
					if (res.status == 201 && checkoutProduct.length !== 0) {
						toast.success("Hurray!! Your Order Placed Successfully", {
							position: "top-right",
							autoClose: 1000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
						})

						setTimeout(() => {
							navigate("/order-placement")
							window.location.reload()
						}, 1200)
					} else if (checkoutProduct.length == 0) {
						toast.error("No Product! , Plase add product and try to checkout", {
							position: "top-right",
							autoClose: 1000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
						})
					}
				})
				.catch((err) => {
					console.log(err)
				})
		}
	}

	const deleteItem = (item, index) => {
		localStorage.removeItem("quickbuy")
		toast.error("deleted!!", {
			position: "top-right",
			autoClose: 1000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		})

		setTimeout(() => {
			navigate("/")
		}, 1200)
	}

	return (
		<>
			{token ? (
				<section className='container mx-auto space-y-4 relative px-3 sm:px-0'>
					<div className='flex justify-between items-center '>
						<p>
							<span className='text-gray-700 font-semibold '> Checkout </span>
							{/* <span className=" text-gray-500 font-normal text-xs sm:text-sm ">
                {quickbuy && `( Total  1 packages worth ৳  500 )`}
				
              </span> */}
						</p>
					</div>

					<div className='sm:grid grid-cols-2 justify-between items-start gap-x-6 '>
						{/* Package */}
						<div className='space-y-4'>
							{quickbuy ? (
								<div className=' h-auto w-full bg-white border border-gray-200 rounded-lg drop-shadow-[0px_0px_32px_rgba(0,0,0,0.04),0px_0px_24px_rgba(0,0,0,0.04),0px_0px_8px_rgba(0,0,0,0.04),0px_0px_1px_rgba(0,0,0,0.04)]  p-4 space-y-2'>
									<div className='space-y-4'>
										<div className=''>
											<p className='text-gray-500 '>
												<span className='font-medium'>Package 1 by </span>
												<span className='text-[#3076CE]'>Abc</span>
											</p>

											<p className='text-gray-500  '>
												<span className='font-small text-sm'>{quickbuy.delivery_type == "R" ? "Regular" : "Express"} Home Delivery by </span>
												<span className='text-[#3076CE]'>20 Nov </span>
											</p>
										</div>

										<div className='grid grid-cols-3 sm:grid-cols-4 justify-center overflow-auto gap-3 sm:gap-6 snap-center scroll-smooth '>
											<figure className='space-y-3'>
												<img className='bg-white h-24 sm:h-44 w-full sm:w-44 object-contain p-4 rounded-md drop-shadow-md' src={quickbuy.product.default_image?.image || quickbuy.product.product_image?.[0]?.image || ""} alt='checkout product' />
												<p className='flex justify-between items-center'>
													<p className='flex justify-start items-center gap-x-2'>
														{(quickbuy.product_discount == null && <span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {quickbuy.product.price * quickbuy.product_quantity}</span>) ||
															(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage == 0 && <span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {quickbuy.product.price * quickbuy.product_quantity}</span>) ||
															(quickbuy.product.product_discount.discount_amount != 0 && quickbuy.product.product_discount.discount_percentage == 0 && (
																<>
																	<span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {(parseInt(quickbuy.product.price) - parseInt(quickbuy.product.product_discount.discount_amount)) * quickbuy.product_quantity}</span>

																	<span className='text-xs font-light  line-through text-gray-400'>৳ {quickbuy.product.price}</span>
																	<span className='text-xs font-light  text-gray-500'>
																		(৳-
																		{parseInt(quickbuy.product.product_discount.discount_amount) * quickbuy.product_quantity})
																	</span>
																</>
															)) ||
															(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage != 0 && (
																<>
																	<span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {(quickbuy.product.price - (quickbuy.product.price / 100) * quickbuy.product.product_discount.discount_percentage) * quickbuy.product_quantity}</span>
																</>
															))}
													</p>
													<TrashIcon onClick={deleteItem} className='h-6 w-6 text-red-500 cursor-pointer' />
												</p>
											</figure>
										</div>
									</div>
								</div>
							) : (
								<div className='flex justify-center items-center h-full w-full'>
									<img className='h-48 w-auto object-contain  ' src={loader} alt='loader' />
								</div>
							)}
						</div>
						<div className='h-auto w-full  bg-white border border-gray-200 rounded-lg drop-shadow-[0px_0px_32px_rgba(0,0,0,0.04),0px_0px_24px_rgba(0,0,0,0.04),0px_0px_8px_rgba(0,0,0,0.04),0px_0px_1px_rgba(0,0,0,0.04)] p-4 space-y-4 text-sm sm:text-base'>
							<p className='text-gray-700 font-medium'>Shipping & Billing</p>

							{/* address */}
							<div className='flex justify-between w-full gap-x-2'>
								<div className='flex justify-start items-start gap-x-2'>
									<LocationMarkerIcon className='h-8 w-8 mx-auto text-gray-500' />

									<div className=''>
										<p className='text-gray-700 font-medium'>{customerProfilelist && customerProfilelist.full_name}</p>
										{userCurrentaddress.message ? (
											<p id='updateAddress' className='text-red-500  text-sm'>
												{userCurrentaddress.message}
											</p>
										) : (
											<p id='updateAddress' className='text-gray-500 font-normal'>
												{userCurrentaddress.label}, {userCurrentaddress.address},{userCurrentaddress.state}, {userCurrentaddress.city},{userCurrentaddress.zipcode}
											</p>
										)}
									</div>
								</div>
							</div>

							{/* phone */}
							<div className='flex justify-between w-full gap-x-2'>
								<div className=' flex-1 flex  justify-start items-start gap-x-2'>
									<PhoneIcon className='h-5 w-5 text-gray-500' />

									<p className='text-gray-700 font-medium'>{customerProfilelist && customerProfilelist.user.phone ? customerProfilelist.user.phone : "Phone number is not available"}</p>
								</div>
							</div>

							{/* email */}
							<div className='flex justify-between w-full gap-x-2'>
								<div className=' flex-1 flex  justify-start items-start gap-x-2'>
									<MailIcon className='h-5 w-5 text-gray-500' />
									<div className=' '>
										<p className='text-gray-700 font-medium'>{customerProfilelist && customerProfilelist.user.email ? customerProfilelist.user.email : "Email is not available"}</p>
									</div>
								</div>
							</div>

							{/* summary */}

							{quickbuy && (
								<div className='border-t border-gray-300 pt-4 space-y-3 '>
									<h2 className='text-gray-700 font-semibold '>Order Summary</h2>
									<div className='flex  justify-between items-center text-gray-500'>
										<span>Subtotal ({quickbuy.product_quantity} Qty)</span>

										<p className='flex justify-start items-center gap-x-2'>
											{(quickbuy.product.product_discount == null && <span className='text-gray-500 font-bold text-base sm:text-lg'>৳ {quickbuy.product.price * quickbuy.product_quantity}</span>) ||
												(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage == 0 && <span className='text-gray-500 font-bold text-base sm:text-lg'>৳ {quickbuy.product.price * quickbuy.product_quantity}</span>) ||
												(quickbuy.product.product_discount.discount_amount != 0 && quickbuy.product.product_discount.discount_percentage == 0 && (
													<>
														<span className='text-gray-500 font-bold text-base sm:text-lg'>৳ {(parseInt(quickbuy.product.price) - parseInt(quickbuy.product.product_discount.discount_amount)) * quickbuy.product_quantity}</span>
													</>
												)) ||
												(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage != 0 && (
													<>
														<span className='text-gray-500 font-bold text-base sm:text-lg'>৳ {(quickbuy.product.price - (quickbuy.product.price / 100) * quickbuy.product.product_discount.discount_percentage) * quickbuy.product_quantity}</span>
													</>
												))}
										</p>
									</div>

									<div>
										<div className='flex  justify-between items-center text-gray-500'>
											<span>Total Delivery Charge</span>
											<span>৳ 0</span>
										</div>
										<p className='text-xs text-gray-400 '>Save Delivery Chargeby Collecting Products from Pickup Points</p>
									</div>

									<div className='flex  justify-between items-center text-gray-500 border-t border-gray-300 pt-4'>
										<p>Total</p>
										<p className='flex justify-start items-center gap-x-2'>
											{(quickbuy.product.product_discount == null && <span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {quickbuy.product.price}</span>) ||
												(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage == 0 && <span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {quickbuy.product.price * quickbuy.product_quantity}</span>) ||
												(quickbuy.product.product_discount.discount_amount != 0 && quickbuy.product.product_discount.discount_percentage == 0 && (
													<>
														<span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {(parseInt(quickbuy.product.price) - parseInt(quickbuy.product.product_discount.discount_amount)) * quickbuy.product_quantity}</span>
													</>
												)) ||
												(quickbuy.product.product_discount.discount_amount == 0 && quickbuy.product.product_discount.discount_percentage != 0 && (
													<>
														<span className='text-[#3076CE] font-bold text-base sm:text-lg'>৳ {(quickbuy.product.price - (quickbuy.product.price / 100) * quickbuy.product.product_discount.discount_percentage) * quickbuy.product_quantity}</span>
													</>
												))}
										</p>
									</div>

									<button onClick={() => setOpen(true)} className='bg-gradient-to-r from-[#2995FC]  to-[#3076CE] py-2 px-4 rounded-lg text-white border border-[#3076CE] font-medium flex justify-center items-center gap-x-2 w-full'>
										Proceed To Pay
									</button>
								</div>
							)}
						</div>
					</div>

					{/* modal */}

					<div>
						<Transition.Root show={open} as={Fragment}>
							<Dialog as='div' className='relative z-30' onClose={setOpen}>
								<Transition.Child as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0' enterTo='opacity-100' leave='ease-in duration-200' leaveFrom='opacity-100' leaveTo='opacity-0'>
									<div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
								</Transition.Child>

								<div className='fixed inset-0 z-10 overflow-y-auto'>
									<div className='flex h-full sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
										<Transition.Child as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' enterTo='opacity-100 translate-y-0 sm:scale-100' leave='ease-in duration-200' leaveFrom='opacity-100 translate-y-0 sm:scale-100' leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
											<Dialog.Panel className='relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-8 -top-52 sm:top-0 '>
												<div className='absolute top-0 right-0 hidden pt-4 pr-4 sm:block'>
													<button type='button' className='rounded-md bg-gray-100  border border-gray-200 text-gray-400 hover:text-gray-500 focus:outline-none ' onClick={() => setOpen(false)}>
														<span className='sr-only'>Close</span>
														<XIcon className='h-6 w-6 text-red-500' aria-hidden='true' />
													</button>
												</div>
												<div className='space-y-2 sm:space-y-0 sm:flex sm:items-center sm:justify-center sm:gap-x-4'>
													<div onClick={() => handleProcessToPay("cash")} className='px-8 py-6 bg-[#3076CE] rounded-lg border border-gray-200 cursor-pointer hover:bg-[#2995FC] flex justify-center items-center gap-x-3'>
														<CashIcon className='h-6 w-6 object-contain text-white' />
														<p
															className=' font-medium sm:text-xl text-white'
															//   onClick={processToCheckout}
														>
															Cash
														</p>
													</div>

													<div onClick={() => handleProcessToPay("digitalCash")} className='px-8 py-6 bg-[#3076CE] rounded-lg border border-gray-200 cursor-pointer hover:bg-[#2995FC] flex justify-center items-center gap-x-3'>
														<CreditCardIcon className='h-6 w-6 object-contain text-white' />
														<p className=' font-medium sm:text-xl text-white'>Digital Payment</p>
													</div>
												</div>
											</Dialog.Panel>
										</Transition.Child>
									</div>
								</div>
							</Dialog>
						</Transition.Root>
					</div>
					<ToastContainer />
				</section>
			) : (
				<Login />
			)}
		</>
	)
}
